import React from 'react'
import "./SubStyle.css"

const CQC_Support = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">Management Support Services</h1>
      <p className="OurServices-pera">Effective leadership is essential for delivering high-quality care. Our Management Support Services provide expert guidance on operational management, governance, compliance, quality assurance, staffing, and performance improvement to help your service run efficiently and confidently.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default CQC_Support
